import React from 'react';

import { createStore, storeConfig } from 'store';

const withUISetup = (Component) => (props) => {
  const store = createStore();
  const { history } = store;

  storeConfig(store);

  return <Component history={history} {...props} />;
};

export default withUISetup;
